import { useEffect, useRef, useState } from 'react'
import { WebView } from 'react-native-webview'
import { View, Text, Pressable } from 'react-native'
import { useFooterApp } from '../../../redux/zustand/footerAppStore'
import { Image } from 'expo-image'
import theme from '../../../../theme'
import NetInfo from '@react-native-community/netinfo'

export const DashboardWeb = () => {
    const footer_app = useFooterApp((state) => state.footer_app)
    const webRef = useRef(null)
    const [url, setUrl] = useState('')
    const [connectionError, setConnectionError] = useState(false)
    const [webViewError, setWebViewError] = useState(false)

    useEffect(() => {
        checkConnection()
        if (footer_app.length === 0) return
        const item = footer_app.find((f) => f.label === 'Dashboard')
        console.log('ITEM ==>', item)
        if (item) {
            setUrl(item.link || '')
        }
    }, [footer_app])

    const checkConnection = async () => {
        const netInfoState = await NetInfo.fetch()
        // if (netInfoState.isConnected) {
        setConnectionError(!netInfoState.isConnected)
        // }
        return
    }
    if (!url || url === '') {
        return (
            <View
                style={{
                    flex: 1,
                    backgroundColor: 'white',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingHorizontal: 60,
                }}
            >
                <Image
                    style={{ width: 140, height: 140 }}
                    source={require('../../../../assets/dashNoRoute.png')}
                />
                <Text
                    style={{
                        marginTop: 10,
                        color: theme.colors.textPrimary,
                        fontWeight: '600',
                        textAlign: 'center',
                        lineHeight: 22,
                        fontSize: 16,
                    }}
                >
                    {'Esta sección no está \nrespondiendo en este momento'}
                </Text>
                <Text
                    style={{
                        marginTop: 5,
                        fontWeight: '400',
                        textAlign: 'center',
                        fontSize: 15,
                        lineHeight: 19,
                        color: theme.colors.darkGray,
                    }}
                >
                    Podés volver al inicio o intentar nuevamente en unos segundos
                </Text>
            </View>
        )
    }
    if (connectionError) {
        return (
            <View
                style={{
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'white',
                    paddingHorizontal: 60,
                }}
            >
                <Image
                    style={{ width: 150, height: 150 }}
                    source={require('../../../../assets/dashNoWifi.png')}
                />
                <Text
                    style={{
                        marginTop: 10,
                        color: theme.colors.textPrimary,
                        fontWeight: '600',
                        textAlign: 'center',
                        lineHeight: 22,
                        fontSize: 16,
                    }}
                >
                    {'Dashboard sin conexión'}
                </Text>
                <Text
                    style={{
                        marginTop: 5,
                        fontWeight: '400',
                        textAlign: 'center',
                        fontSize: 15,
                        lineHeight: 19,
                        color: theme.colors.darkGray,
                    }}
                >
                    Podrás ver el dashboard cuando vuelvas a tener conexión. Verifica
                    tu conexión e intenta nuevamente
                </Text>
                <Pressable
                    style={{
                        marginTop: 20,
                        backgroundColor: 'white',
                        borderRadius: 20,
                        width: '75%',
                        paddingVertical: 10,
                        borderColor: theme.colors.colorPrimary,
                        borderWidth: 1,
                    }}
                    onPress={() => checkConnection()}
                >
                    <Text
                        style={{
                            color: theme.colors.colorPrimary,
                            fontWeight: '700',
                            textAlign: 'center',
                            fontSize: 15,
                        }}
                    >
                        Reintentar
                    </Text>
                </Pressable>
            </View>
        )
    }
    return (
        <View style={{ flex: 1 }}>
            <WebView
                key={url}
                ref={webRef}
                source={{ uri: url }}
                style={{ flex: 1 }}
                startInLoadingState={true}
                scalesPageToFit={true}
                allowFileAccess={true}
                allowUniversalAccessFromFileURLs={true}
                onContentProcessDidTerminate={(data) => {}}
                originWhitelist={['*']}
                onHttpError={() => console.log('Error http')}
                onError={(error) => {
                    setWebViewError(true)
                    console.log('Error cargando la pagina =>', error)
                }}
                onLoadEnd={() => {
                    setWebViewError(false)
                }}
                onMessage={(event) => {}}
            />

            {webViewError && (
                <Pressable
                    style={{
                        position: 'absolute',
                        alignSelf: 'center',
                        bottom: 12,
                        backgroundColor: 'white',
                        borderRadius: 20,
                        width: '75%',
                        paddingVertical: 10,
                        borderColor: theme.colors.colorPrimary,
                        borderWidth: 1,
                    }}
                    onPress={() => {
                        webRef?.current?.reload()
                        setWebViewError(false)
                    }}
                >
                    <Text
                        style={{
                            color: theme.colors.colorPrimary,
                            fontWeight: '700',
                            textAlign: 'center',
                            fontSize: 15,
                        }}
                    >
                        Reintentar
                    </Text>
                </Pressable>
            )}
        </View>
    )
}
